import { render, staticRenderFns } from "./couponPrice.vue?vue&type=template&id=9c815a1e&scoped=true&"
import script from "./couponPrice.vue?vue&type=script&lang=js&"
export * from "./couponPrice.vue?vue&type=script&lang=js&"
import style0 from "./couponPrice.vue?vue&type=style&index=0&id=9c815a1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c815a1e",
  null
  
)

export default component.exports